import { ToastService } from 'src/app/services/toast.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-responsive',
    templateUrl: './responsive.component.html',
    styleUrls: ['./responsive.component.scss'],
    standalone: false
})
export class ResponsiveComponent implements OnInit, OnDestroy {

  currentEmail: string;
  // 'activating' mientras corre activateUser; 'done' cuando la cuenta quedo activa
  status: 'activating' | 'done' = 'activating';

  constructor(
    private route: ActivatedRoute,
    public userService: UserService,
    private toast: ToastService,
    private router: Router,
    private meta: Meta
  ) { }

  ngOnInit() {
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });

    this.route.queryParams.subscribe(params => {
      if (!params.b) {
        this.router.navigate(['/login']);
        return;
      }
      this.userService.activateUser(params.b).subscribe(
        () => {
          this.status = 'done';
          this.toast.success('Your account has been successfully activated');
        },
        () => {
          this.toast.error('Activation link is invalid or has expired.');
          this.router.navigate(['/login']);
        }
      );
    });

    this.currentEmail = localStorage.getItem('email');
  }

  ngOnDestroy() {
    this.meta.removeTag('name="robots"');
  }

  onAcceptTerm() {
    this.userService.activateUser(this.currentEmail).subscribe(() => {
      this.router.navigateByUrl('/home');
    });
  }

  goLogin() {
    this.router.navigateByUrl('/login');
  }
}
